<template>
  <div class="view-layout">
    <m-widget-head class="content-widget-head">
      <!--active-button :active="isActive('section', 'deposit')" @click="$router.push('/account/payments/deposit')">{{ $t('account.payments.tabs.deposit') }}</active-button-->
      <active-button :active="isActive('section', 'withdrawal')" @click="$router.push('/account/payments/withdrawal')">{{ $t('account.payments.tabs.withdrawal') }}</active-button>
      <active-button :active="isActive('section', 'history')" @click="$router.push('/account/payments/history')">{{ $t('account.payments.tabs.history') }}</active-button>
      <template slot="right">
        <div class="date-range" v-if="isActive('section', 'history')">
          <div class="caption">{{ $t('common.date-range.from') }}</div>
          <date-button :date="$route.params.from" @change="followFrom" />
          <div class="caption">{{ $t('common.date-range.to') }}</div>
          <date-button :date="$route.params.to" @change="followTo" />
        </div>
      </template>
    </m-widget-head>
    <div class="content-layout">
      <router-view />
    </div>
  </div>
</template>

<script>
import MWidgetHead from '@/components/widget/MWidgetHead'
import MScrollbar from '@/components/MScrollbar'
import ActiveButton from '@/components/buttons/ActiveButton'
import DateButton from '@/components/buttons/DateButton'

export default {
  components: {
    MWidgetHead,
    MScrollbar,
    ActiveButton,
    DateButton
  },
  methods: {
    followFrom (date) {
      this.$router.push(`/account/payments/history/from/${date}/to/${this.$route.params.to}`)
    },
    followTo (date) {
      this.$router.push(`/account/payments/history/from/${this.$route.params.from}/to/${date}`)
    }
  }
}
</script>

<style scoped>
.view-layout { height: 100%; }
.content-layout { height: 100%; margin-top: -40px; padding: 50px 0 10px; }
.content-widget-head { margin: 0 10px; }

.active-button { height: 40px; line-height: 40px; padding: 0 10px; }

.date-range { display: flex; }
.date-range .caption { color: #999; font-size: 14px; }
</style>



// WEBPACK FOOTER //
// src/components/account/payments/View.vue